export class schedulequery {
    user_guid: string;
    fromdate: string;
    todate: string;
}

export class ScheduleCreate {
    user_guid: string;
    from_date: string;
    to_date: string;
    end_date?: string;
}

export class SlotData {
    slot_id: number;
    slot_time: Date;
}

export class Schedule extends SlotData {
    date: string;
    status: boolean;
    sr_no: number;
    block: boolean;
}

export class ScheduleBlock {
    schedule_ids: number[];
}

export class DefaultSlotsQuery {
    reschedule?: boolean;
    is_diet?: boolean;
}